import { render, staticRenderFns } from "./seatsioEventStatic.vue?vue&type=template&id=3ce3bea2&scoped=true&"
import script from "./seatsioEventStatic.vue?vue&type=script&lang=js&"
export * from "./seatsioEventStatic.vue?vue&type=script&lang=js&"
import style0 from "./seatsioEventStatic.vue?vue&type=style&index=0&id=3ce3bea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce3bea2",
  null
  
)

export default component.exports